 <template>
  <div v-if="fluxerSelected">
    <md-sidenav @close="close()" class="md-right" ref="rightSidenav">
        <md-toolbar>
            <div class="md-toolbar-container">
                <h3 class="md-title">Acuerdo de Objetivos</h3>
                <md-button @click.native="closeRightSidenav()" class="md-icon-button close">
                    <md-icon>close</md-icon>
                </md-button>
            </div>
        </md-toolbar>
        
        <md-subheader>
            <div v-if="acuerdo">Dueño {{acuerdo.ownerObject.displayName}}</div>
        </md-subheader>

        <md-layout md-gutter>

            <md-card md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-align="center" class="card-obj" v-for="(obj, index) in objetivos" :key="index">
                <md-card-header>
                    <div class="md-title">Objetivo {{index + 1}}</div>
                    <md-button @click.native="deleteObj(index)" class="md-icon-button delete-obj">
                        <md-icon>close</md-icon>
                    </md-button>
                </md-card-header>
                <md-card-content>
                    <md-input-container>
                        <label>Descripcion</label>
                        <md-input v-model="obj.descripcion" debounce="5000" required="true"></md-input>
                    </md-input-container>
                    <md-input-container>
                        <label>Notas</label>
                        <md-input v-model="obj.notas" debounce="5000" required="true"></md-input>
                    </md-input-container>
                </md-card-content>
            </md-card>

            <md-card md-flex-xsmall="100" md-flex-small="50" md-flex-medium="50" md-align="center" class="card-obj">
                <md-card-header>
                    <div class="md-title">Nuevo Objetivo</div>
                </md-card-header>
                <md-card-content>
                    <md-button @click.native="addObjetivo()" class="md-icon-button md-raised md-dense">
                        <md-icon>add</md-icon>
                    </md-button>
                </md-card-content>
            </md-card>

        </md-layout>
        <div class="container-buttons" v-if="!acuerdo.sent">
            <md-button class="md-raised md-primary" @click.native="guardar()">Guardar borrador</md-button>
            <md-button class="md-raised md-primary" @click.native="enviar()">Enviar</md-button>
        </div>
    </md-sidenav>
    <md-snackbar :md-position="'bottom center'" ref="snackbar" :md-duration="3000">
        <span>El acuerdo de objetivos se envio correctamente a {{fluxerSelected.displayName}}</span>
    </md-snackbar>
  </div>
</template>

<script>
import ObjetivosService from '../services/objetivos'
import NotificationsService from '../services/notifications'
import FluxerService from '../services/fluxer'
import Router from '../router'

export default {
  name: 'set-objetivos',
  data () {
    return {
      fluxerSelected: this.$route.params.fluxerSelected,
      acuerdo: false
    }
  },
  firebase: function () {
    return {
      objetivos: ObjetivosService.getObjetivosByAcuerdo(this.$route.params.id)
    }
  },
  mounted: function () {
    ObjetivosService.getById(this.$route.params.id).then((response) => {
      this.acuerdo = response.data
    })
  },
  beforeUpdate: function () {
    if (this.$refs.rightSidenav) {
      this.$refs.rightSidenav.open()
    }
  },
  methods: {
    close () {
      Router.replace({name: 'acuerdo-objetivos'})
    },
    toggle () {
      this.$refs.rightSidenav.toggle()
    },
    closeRightSidenav () {
      this.$refs.rightSidenav.close()
    },
    addObjetivo () {
      let obj = {
        descripcion: '',
        notas: '',
        cumplido: false
      }
      this.objetivos.push(obj)
    },
    deleteObj (index) {
      this.objetivos.splice(index, 1)
    },
    guardar () {
      ObjetivosService.guardar(this.$route.params.id, this.objetivos).then(() => {
        this.closeRightSidenav()
      })
    },
    enviar () {
      let acuerdo = this.acuerdo
      ObjetivosService.enviar(this.$route.params.id, this.objetivos).then(() => {
        NotificationsService.enviarObjetivos(acuerdo, FluxerService.getCurrentUser())
        this.$refs.snackbar.open()
        this.closeRightSidenav()
      })
    }
  }
}
</script>

<style>
    .close {
        right: 0;
        position: absolute !important;
    }

    .form-question {
        padding: 0 16px;
    }

    .card-obj {
        margin: 10px;
        width: 280px;
        height: 244px !important;
    }

    .delete-obj {
        position: absolute !important;
        top: 0px;
        right: 5px;
    }

    .container-buttons {
        padding: 20px 0;
    }
</style>



// WEBPACK FOOTER //
// SetObjetivos.vue?6a988d34